<template>
  <el-dialog
    title="成品拆卸详情"
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-descriptions title="" :column="3" border size="mini" v-if="model.id">
      <el-descriptions-item label="拆卸基地">{{
        model.base.name
      }}</el-descriptions-item>
      <el-descriptions-item label="拆卸日期">{{
        model.disassemb_date
      }}</el-descriptions-item>
      <el-descriptions-item label="是否使用">
        <span v-if="model.is_used == 1">是</span>
        <span v-else-if="model.is_used == 2">否</span>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="拆检情况">{{
        model.inspection
      }}</el-descriptions-item>
      <el-descriptions-item label="图片"
        ><el-image
          v-for="url in model.imgs"
          :key="url"
          style="width: 30px; height: 30px; margin-right: 5px"
          :src="url"
          :preview-src-list="model.imgs"
        >
        </el-image
      ></el-descriptions-item>
      <el-descriptions-item label="视频">
        <VideoPlayer :srcs="model.videos"></VideoPlayer>
      </el-descriptions-item>
    </el-descriptions>

    <p class="bold m-t-20">配件拆检情况</p>
    <el-table :data="model.item_records" border size="small" v-if="model.id">
      <el-table-column prop="item.name" label="名称"></el-table-column>
      <el-table-column prop="item.code" label="编号"></el-table-column>
      <el-table-column label="拆检情况" prop="inspection">
        <template slot-scope="scope">
          <el-input
            type="textarea"
            autosize
            v-model="scope.row.inspection"
            v-if="editIndex == scope.$index"
          ></el-input>
          <span v-else>{{ scope.row.inspection }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <FileUpload
            v-model="scope.row.imgs"
            v-if="editIndex == scope.$index"
          ></FileUpload>
          <el-image
            v-else
            v-for="url in scope.row.imgs"
            :key="url"
            style="width: 30px; height: 30px; margin-right: 5px"
            :src="url"
            :preview-src-list="scope.row.imgs"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="视频">
        <template slot-scope="scope">
          <VideoUploader
            v-model="scope.row.videos"
            v-if="editIndex == scope.$index"
          ></VideoUploader>
          <VideoPlayer :srcs="scope.row.videos" v-else></VideoPlayer>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        v-permission="
          category == 1 ? Auth.productDisassemble : Auth.instrumentDisassemble
        "
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            plain
            @click="handleUpdate(scope.row, scope.$index)"
            v-if="editIndex == scope.$index"
            >保存</el-button
          >
          <el-button
            v-else
            size="mini"
            type="primary"
            plain
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { itemRecordUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
      editIndex: -1,
    }
  },

  methods: {
    handleEdit(item, index) {
      this.editIndex = index
    },

    async handleUpdate(item, index) {
      let res = await itemRecordUpdate(item)
      if (res.code == 0) {
        this.$message.success('保存成功')
        this.$set(this.model.item_records, index, res.data)
        this.editIndex = -1
      }
    },
  },
}
</script>
